import { useLateralMenu } from './useLateralMenu'

export {
  useLateralMenu
}
